import BaseModelAPI from '../BaseModelAPI';

export default class FinishGoodQualityInspectionNg extends BaseModelAPI {
	static entity = 'finishgoodqualityinspectionng';
	static entityName = 'finishgoodqualityinspectionng';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.finishGoodQualityInspectionId = '';
			this.finishGoodQualityInspection = {};
			this.problemCategoryId = '';
			this.problemCategory = {};
			this.qtyNg = 0;
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

	static async showImageEvidence(this_, id) {
		return await this_.$http.get(`${this.entityName}/showImageEvidence/${id}`)
			.then(async function (response) {
				if (response.data) {
					return response.data;
				}
				return null;
			})
			.catch(function (error) {
				this_.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			});
    }

}